import react, { useState } from "react";
import muiTheme from "../../../../themes/muiTheme";
import { alpha, styled } from "@mui/system";
import { Box, Typography } from "@mui/material";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { Menu } from "../../../../model/menu";

interface Props {
  sub: Menu;
  viewWidth: number;
  currentPage: number;
  isOpen: boolean;
  isPortrait: boolean;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  closeDrawer: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AccordionSection = ({
  sub,
  viewWidth,
  currentPage,
  isOpen,
  isPortrait,
  setPage,
  closeDrawer,
}: Props) => {
  const [isAccordionExpanded, setAccordionExpanded] = useState(false);

  const handleChange = (event: any, isExpanded: boolean) => {
    setAccordionExpanded(isExpanded);
  };

  return (
    <Accordion
      id={sub.title}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: !isPortrait ? 208 : viewWidth - 56,
      }}
      expanded={isAccordionExpanded}
      onChange={handleChange}
    >
      <AccordionSummary
        sx={{
          width: !isPortrait ? 208 : viewWidth - 32,
          px: 1.2,
          m: 0,
          display: "flex",
          alignItems: "center",
          justifyContents: "center",
          ":hover": {
            backgroundColor: isPortrait ? null : muiTheme.palette.grey[200],
          },
        }}
        expandIcon={
          <Box
            component="img"
            src="../img/ic_dropdown_down.png"
            sx={{
              width: 16,
              bgcolor: "transparent",
            }}
          />
        }
      >
        <Typography
          variant={isAccordionExpanded ? "tm-b" : "tm-r"}
          color={
            isAccordionExpanded
              ? muiTheme.palette.blue[500]
              : muiTheme.palette.grey[900]
          }
        >
          {sub.title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          display: "flex",
          flexDirection: "column",
          pl: 2,
          pt: 0.4,
          pb: 0.8,
        }}
      >
        {sub.subList!.map((detail) => (
          <Box
            sx={{
              display: "flex",
              px: 1.2,
              py: 0.6,
              width: !isPortrait ? 164 : viewWidth - 84,
              borderLeft: "1px solid",
              borderColor: muiTheme.palette.grey[300],
              cursor: "pointer",
              userSelect: "none",
              ":hover": {
                backgroundColor: isPortrait ? null : muiTheme.palette.grey[200],
              },
            }}
            onClick={() => {
              if (detail.page === undefined || detail.page < 0) {
                return;
              }
              if (isPortrait) {
                closeDrawer(!isOpen);
              }
              setPage(detail.page);
            }}
          >
            <Typography
              variant={
                isClickedSection(currentPage, detail.page) ? "ts-b" : "ts-r"
              }
              color={
                isClickedSection(currentPage, detail.page)
                  ? muiTheme.palette.blue[500]
                  : muiTheme.palette.grey[900]
              }
            >
              {detail.title}
            </Typography>
          </Box>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

function isClickedSection(currentPage: number, sectionPage: number) {
  return currentPage === sectionPage;
}

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  "&:not(:last-child)": {
    borderBottom: 0,
    padding: 0,
    margin: 0,
  },
  "&::before": {
    display: "none",
    margin: 0,
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    // expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}

    {...props}
  />
))(({ theme }) => ({
  width: 208,
  minHeight: 0,
  "& .MuiAccordionSummary-content": {
    padding: theme.spacing(0.4, 0),
    margin: 0,
  },
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(180deg)",
    padding: 0,
    margin: 0,
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(0.4, 0),
  width: 100,
}));
